import { render, staticRenderFns } from "./Destaque.vue?vue&type=template&id=3424dca2&"
import script from "./Destaque.vue?vue&type=script&lang=ts&"
export * from "./Destaque.vue?vue&type=script&lang=ts&"
import style0 from "./Destaque.vue?vue&type=style&index=0&id=3424dca2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports